












































































































































































































































































































































































































































































































































































import { serialize } from "class-transformer";
import { Component, Inject, Mixins, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import BeforeUnload from "../../mixins/BeforeUnload";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import FormDirtyOnLeavePage from "../private/forms/FormDirtyOnLeavePage.vue";
import { Form } from "../../models/Form";
import ProjectProposalUploadFiles from "./ProjectProposalUploadFiles.vue";

@Component({
    beforeRouteLeave(
        this: ProjectProposalSupportingDocumentsInfrastructure,
        to: Route,
        from: Route,
        next: NavigationGuardNext<Vue>
    ) {
        this.isDirty ? (this.showModal = true) : next();
    },
    components: {
        FormDirtyOnLeavePage,
        ProjectProposalUploadFiles
    }
})
export default class ProjectProposalSupportingDocumentsInfrastructure extends Mixins(
    ProjectProposalMixin,
    Utils,
    BeforeUnload
) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;

    response: Form | null = null;
    total = 0;
    loading = true;
    originalData = "";
    showModal = false;
    isDirty = false;
    isValid: string[] = [];
    endDate: string | null = "";
    totalFiles = 0;

    @Watch("response.file_ids", { immediate: true })
    @Watch("response.upload_urls", { immediate: true })
    onFiles() {
        if (this.response) {
            this.totalFiles = this.response.file_ids.length + this.response.upload_urls.length;
        }
    }

    @Watch("response", { deep: true })
    onRowsChange() {
        this.setBeforeUnload();
    }

    async loadData() {
        this.loading = true;
        const [data, err] = await this.maltaModule.projectProposalApi.getDocumentUpload(
            this.subjectId,
            this.applicationId,
            this.docCode
        );
        if (err) {
            if (err.response && err.response.status !== 404) this.goHomeGenericError();
            else {
                const [resp, err] = await this.maltaModule.projectProposalApi.getDocumentConfigUpload(
                    this.subjectId,
                    this.applicationId,
                    this.docCode
                );
                if (err) this.goHomeGenericError();
                else {
                    this.originalData = serialize(data);
                    this.response = resp;
                }
            }
        } else if (data) {
            this.originalData = serialize(data);
            this.response = data;
        }
        this.loading = false;
    }

    async mounted() {
        await this.loadData();
    }

    backToHome(force = false) {
        if (force) {
            this.unsetBeforeUnload();
            this.originalData = serialize(this.response);
        }
        this.isDirty = this.originalData !== serialize(this.response);
        this.goHome();
    }

    async saveAndGoBack() {
        if (this.response) {
            this.isValid = this.response.isValid;
            if (this.isValid.length === 0) {
                const [resp, err] = this.response.documentId
                    ? await this.maltaModule.projectProposalApi.setDocumentUpload(
                          this.subjectId,
                          this.applicationId,
                          this.docCode,
                          this.response.documentId,
                          this.response.parsedUploadDocuments
                      )
                    : await this.maltaModule.projectProposalApi.createDocumentUpload(
                          this.subjectId,
                          this.applicationId,
                          this.docCode,
                          this.response.parsedUploadDocuments
                      );
                if (err) this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                else {
                    this.unsetBeforeUnload();
                    this.originalData = serialize(resp);
                    this.response = resp;
                    this.isDirty = false;
                    this.$emit("reload");
                    this.toast(this.i18n("saved-item").toString(), { type: "success" });
                    this.goHome(true);
                }
            } else this.toast(this.i18n("form-not-valid").toString(), { type: "error" });
        }
    }

    beforeDestroy() {
        this.unsetBeforeUnload();
    }

    get docCode(): string {
        return `MA_CAP_SP_SUP_DOC_${this.contract?.module_code}`;
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    getRowCode(row: string) {
        return `${this.docCode}_${row}`;
    }
}
